export default __webpack_public_path__ + "img/allIcon-7b30c857.png";